import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-historico-endereco',
  templateUrl: './consulta-historico-endereco.component.html',
  styleUrls: ['./consulta-historico-endereco.component.scss']
})
export class ConsultaHistoricoEnderecoComponent implements OnInit {
  title = "ENDEREÇO INFORMADOS ANTERIORMENTE";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
